import { useState } from 'react';

const useFormErrors = () => {
	const [displayErrors, setDisplayErrors] = useState<string[]>([]);

	return { displayErrors, setDisplayErrors };
};

export default useFormErrors;
